import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from "axios";
import reportWebVitals from './reportWebVitals';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import App from './App';
import './index.css';
import ErrorPage from './pages/ErrorPage';
import SignUp from './pages/SignUp';
import Login from './pages/LogIn';
import Dashboard from './pages/Dashboard';
import PrivateRoute from './components/PrivateRoute';

axios.defaults.withCredentials = true;

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/signup",
    element: <SignUp />,
    
  },
  {
    path: "/login",
    element: <Login />,
    
  },
  {
    path: '/dashboard/:userId',
    element: (
      <PrivateRoute>
      <Dashboard />
    </PrivateRoute>
  )
  }

])
//import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
